import React,{useEffect} from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


function BackDrop() {
    
    const classes=useStyles()
    const [open, setOpen] = React.useState(true);
    const handleClose = () => {
        setTimeout(() => {
            setOpen(false);            
        }, 3000);
    };
    
    
    useEffect(() => {
        handleClose()    
        
    }, [])

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default BackDrop